<div class="footer2">
  <div class="flex-row w-100 ps-2">
    <div>
      <div class="logo">
        <a href="https://dpcdata.com/" target="_blank"> <img src="assets/img/dpc_logo.png" alt="DPC DATA Logo"></a>
      </div>
      <div>
        <ul class="p-0">
          <li><a class="main-text-font link-font-size" (click)="openAboutUs()">About Us</a></li>
          <li><a class="main-text-font link-font-size" (click)="disclaimer()">Disclaimer</a></li>
          <li><a class="main-text-font link-font-size" (click)="openTermsOfUse()">Terms of Use</a></li>
          <li><a class="main-text-font link-font-size" (click)="openContactUs()">Contact Us</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
